import { SetupMarker } from './accountSetupStorage';

export interface SignInByEmailPayload {
  email: string;
  password: string;
  username: string;
}

export interface SignInByEmailResponse {
  accessToken?: string;
  userId?: string;
  challenge?: string;
  session?: string;
  email?: string;
  username?: string;
}

export interface RespondNewPasswordChallengePayload {
  email: string;
  session: string;
  username?: string;
  password: string;
}

export interface ForgotPasswordPayload {
  email: string;
}

export interface ForgotPasswordResponse {
  error: boolean;
  data: {
    CodeDeliveryDetails: {
      AttributeName: 'email';
      DeliveryMedium: 'EMAIL';
      Destination: string;
    };
  };
  '': '';
}

export interface ResetPasswordPayload {
  email: string;
  password: string;
  confirmPassword: string;
  code: string;
}

export interface SignUpStringField {
  type: 'string';
  defaultValue: string;
  key: string;
  placeHolder: string;
  required: boolean;
}
export interface SignUpCheckBoxField {
  type: 'checkbox';
  defaultValue: boolean;
  key: string;
  required: boolean;
  text: string;
}

export type SignUpField = SignUpStringField | SignUpCheckBoxField;

export enum AccountType {
  'Investor' = 'Investor',
  'Realtor' = 'Realtor',
  'Issuer' = 'Issuer',
}

export enum SubAccountType {
  'Investor_Individual' = 'Investor_Individual',
  'Investor_Company' = 'Investor_Company',
}

export interface SubTypes {
  label: string;
  value: SubAccountType.Investor_Company | SubAccountType.Investor_Individual;
  fields?: SignUpField[];
}

export interface SignUpConfigResponse {
  isSSOEnabled: boolean;
  accountTypes: {
    key: AccountType;
    info: string;
    fields?: SignUpField[];
    types?: SubTypes[];
  }[];
}
export interface SSOSignUpResponse {
  userExists: boolean;
  accessToken: string;
  userInfo: {
    email: string;
    email_verified: boolean;
    name: string;
    picture: string;
    given_name: string;
    family_name: string;
  };
}

export type SignUpByEmailPayload = SignInByEmailPayload;

export interface SignUpByEmailResponse {
  username: string;
  userId: string;
  isUserConfirmed: boolean;
}

export interface VerifySignUpOtpPayload {
  username: string;
  code: string;
  password: string;
}

export type VerifySignUpOtpResponse = SignInByEmailResponse;

export type CompleteSignUpPayload = Record<string, any>;

export interface BaseFormConfig {
  info: string;
  key: AccountType;
  fields?: SignUpField[] | undefined;
  types?: SubTypes[] | undefined;
}

export interface FormConfig {
  Issuer: BaseFormConfig | undefined;
  Realtor: BaseFormConfig | undefined;
  Investor: BaseFormConfig | undefined;
}

export interface AuthState {
  isUserAuthenticated: boolean;
  role: any;
  user: User | null;
  token: string | null;
  accountType: AccountType | undefined;
  subAccountType: string | undefined;
  forms: FormConfig;
  email: string;
  password: string;
  username: string;
  // An unresolved account setup found by a submission (P6).
  setupMarker: SetupMarker | null;
  // A getMe for the current session failed with a 5xx or a network error.
  accountLoadFailed: boolean;
}

export interface User {
  id: string;
  email: string;
  roles?: {
    companyName: string;
    group: string;
    id: string;
    title: string;
  }[];
  username: string;
  displayName: string;
  profilePicture: string;
  userSettings: Record<string, unknown>;
  userProfile: UserProfile;
  // The resolved active role from /v2/me, or null when no role is active.
  activeRoleId?: string | null;
}

export interface UserProfile {
  companyName: string;
  signature: string;
  initials: string;
}
